import { useEffect, useRef } from 'react';

const useInterval = (callback, delay = null) => {
  const latestCallback = useRef(() => {});

  useEffect(() => {
    latestCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay !== null) {
      const interval = setInterval(() => latestCallback.current(), delay || 0);
      return () => clearInterval(interval);
    }
    return;
  }, [delay]);
};

export default useInterval;
